<template>
  <div
    v-show="show"
    class="relative col-start-1 row-start-1 col-span-6 w-full h-full cursor-not-allowed"
  >
    <div class="w-full h-full bg-black bg-opacity-50 rounded-md"></div>
    <slot>
      <!-- eslint-disable-next-line max-len -->
      <div class="absolute inset-0 z-10 flex items-center justify-center font-bold text-white">Not Required</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'account-overlay',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
